window.ahUpdateShipping = function() {
  var costEl = document.getElementById('shipping-cost-value');
  if (!costEl) return;

  if (!window.AH_SHIPPING) {
    costEl.textContent = 'Select a size';
    return;
  }

  // Handle flat rate products (no size variants)
  if (window.AH_SHIPPING['flat'] !== undefined) {
    costEl.textContent = '$' + window.AH_SHIPPING['flat'];
    return;
  }

  var sizeSelect = null;
  var selects = document.querySelectorAll('select');
  for (var i = 0; i < selects.length; i++) {
    var parent = selects[i].closest('.product-form__input');
    if (parent && parent.textContent.indexOf('Size') > -1) {
      sizeSelect = selects[i];
      break;
    }
  }
  if (!sizeSelect && selects.length > 0) sizeSelect = selects[0];
  if (!sizeSelect) { costEl.textContent = 'Select a size'; return; }

  var selectedText = sizeSelect.options[sizeSelect.selectedIndex].text;
  var match = selectedText.match(/^(\d+)/);
  if (!match) { costEl.textContent = 'Select a size'; return; }

  var sizeKey = match[1] + '"';
  var cost = window.AH_SHIPPING[sizeKey];
  costEl.textContent = (cost !== undefined) ? '$' + cost : 'Contact us for estimate';
};

document.addEventListener('DOMContentLoaded', function() {
  window.ahUpdateShipping();
  document.querySelectorAll('select').forEach(function(s) {
    s.addEventListener('change', function() {
      setTimeout(window.ahUpdateShipping, 100);
    });
  });
});

var ahLastUrl = window.location.href;
setInterval(function() {
  if (window.location.href !== ahLastUrl) {
    ahLastUrl = window.location.href;
    setTimeout(window.ahUpdateShipping, 200);
  }
}, 200);